type MobiusConfig = {
  [program: string]: {
    [school: string]: {
      apiKey: string;
      domain: string;
    };
  };
};

export const mobiusConfig: MobiusConfig = {
  ucb: {
    data: {
      apiKey: "ece9cb8b-32fd-49c4-9720-dc8ef891452f",
      domain: ".berkeley.edu",
    },
  },
};
